
import { createContext } from "react";

/**
 * @description NotificationContext that allows to send / remove notifications
 * */
export const NotificationContext = createContext({
    notifications: [],
    addNotification: () => { },
    removeNotification: () => { }
});
